// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/user_avatars.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SrcSet } from "./images";
/**
 * @generated from protobuf message c1.api.assets.v1.UserAvatar
 */
export interface UserAvatar {
    /**
     * @generated from protobuf field: c1.api.assets.v1.UserAvatarRef user_avatar = 1
     */
    userAvatar?: UserAvatarRef;
    /**
     * @generated from protobuf field: string src = 2
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 3
     */
    srcSet?: SrcSet;
}
/**
 * @generated from protobuf message c1.api.assets.v1.UserAvatarRef
 */
export interface UserAvatarRef {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetUserAvatarsRequest
 */
export interface BulkGetUserAvatarsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.UserAvatarRef user_avatars = 1
     */
    userAvatars: UserAvatarRef[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetUserAvatarsResponse
 */
export interface BulkGetUserAvatarsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.UserAvatar list = 1
     */
    list: UserAvatar[];
}
// @generated message type with reflection information, may provide speed optimized methods
class UserAvatar$Type extends MessageType<UserAvatar> {
    constructor() {
        super("c1.api.assets.v1.UserAvatar", [
            { no: 1, name: "user_avatar", kind: "message", T: () => UserAvatarRef },
            { no: 2, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
    create(value?: PartialMessage<UserAvatar>): UserAvatar {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.src = "";
        if (value !== undefined)
            reflectionMergePartial<UserAvatar>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAvatar): UserAvatar {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.UserAvatarRef user_avatar */ 1:
                    message.userAvatar = UserAvatarRef.internalBinaryRead(reader, reader.uint32(), options, message.userAvatar);
                    break;
                case /* string src */ 2:
                    message.src = reader.string();
                    break;
                case /* c1.api.assets.v1.SrcSet src_set */ 3:
                    message.srcSet = SrcSet.internalBinaryRead(reader, reader.uint32(), options, message.srcSet);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAvatar, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.UserAvatarRef user_avatar = 1; */
        if (message.userAvatar)
            UserAvatarRef.internalBinaryWrite(message.userAvatar, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string src = 2; */
        if (message.src !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.src);
        /* c1.api.assets.v1.SrcSet src_set = 3; */
        if (message.srcSet)
            SrcSet.internalBinaryWrite(message.srcSet, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.UserAvatar
 */
export const UserAvatar = new UserAvatar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAvatarRef$Type extends MessageType<UserAvatarRef> {
    constructor() {
        super("c1.api.assets.v1.UserAvatarRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAvatarRef>): UserAvatarRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<UserAvatarRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAvatarRef): UserAvatarRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAvatarRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.UserAvatarRef
 */
export const UserAvatarRef = new UserAvatarRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetUserAvatarsRequest$Type extends MessageType<BulkGetUserAvatarsRequest> {
    constructor() {
        super("c1.api.assets.v1.BulkGetUserAvatarsRequest", [
            { no: 1, name: "user_avatars", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAvatarRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkGetUserAvatarsRequest>): BulkGetUserAvatarsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAvatars = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetUserAvatarsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetUserAvatarsRequest): BulkGetUserAvatarsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.UserAvatarRef user_avatars */ 1:
                    message.userAvatars.push(UserAvatarRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetUserAvatarsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.UserAvatarRef user_avatars = 1; */
        for (let i = 0; i < message.userAvatars.length; i++)
            UserAvatarRef.internalBinaryWrite(message.userAvatars[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetUserAvatarsRequest
 */
export const BulkGetUserAvatarsRequest = new BulkGetUserAvatarsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetUserAvatarsResponse$Type extends MessageType<BulkGetUserAvatarsResponse> {
    constructor() {
        super("c1.api.assets.v1.BulkGetUserAvatarsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAvatar }
        ]);
    }
    create(value?: PartialMessage<BulkGetUserAvatarsResponse>): BulkGetUserAvatarsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetUserAvatarsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetUserAvatarsResponse): BulkGetUserAvatarsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.UserAvatar list */ 1:
                    message.list.push(UserAvatar.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetUserAvatarsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.UserAvatar list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAvatar.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetUserAvatarsResponse
 */
export const BulkGetUserAvatarsResponse = new BulkGetUserAvatarsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.assets.v1.UserAvatarService
 */
export const UserAvatarService = new ServiceType("c1.api.assets.v1.UserAvatarService", [
    { name: "BulkGetUserAvatars", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetUserAvatarsRequest, O: BulkGetUserAvatarsResponse }
]);
